import * as Linking from "expo-linking";
import { Platform } from "react-native";

export const APP_SCHEME = "ferinacura";

export const linkingPrefixes = [
  Linking.createURL("/"),
  `${APP_SCHEME}://`,
  "https://app.ferina-cura.de",
];

/** Recovery-Redirect für resetPasswordForEmail. Previews nutzen den aktuellen Origin. */
export function recoveryRedirectUrl(): string {
  if (Platform.OS === "web" && typeof window !== "undefined") {
    return `${window.location.origin}/auth/recovery`;
  }
  return Linking.createURL("/auth/recovery");
}

export function queryParam(url: string | null, key: string): string | null {
  if (!url) return null;
  const parsed = Linking.parse(url);
  const value = parsed.queryParams?.[key];
  if (typeof value === "string" && value.length > 0) return value;
  if (Array.isArray(value) && typeof value[0] === "string") return value[0];
  return null;
}
